import React, {useEffect, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
// import {useDispatch} from 'react-redux';
// import {loadUser, logoutUser} from '@store/reducers/auth';
import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import Account from '@pages/account/Account';
import AccountAdd from '@pages/account/AccountAdd';
import AccountEdit from '@pages/account/AccountEdit';

import EmailConfig from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit from '@pages/emailConfig/EmailConfigEdit';

import Log from '@pages/log/Log';

import LoginHistory from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory from '@app/pages/report/countLogin/StatisticLoginHistory';

// import ReportPostByWebAnalysis from '@pages/report/ReportPostByWebAnalysis';
// import ReportPostQuantityCreateBy from '@app/pages/report/ReportPostQuantityCreateBy';
// import ReportPostCreateBy from '@app/pages/report/ReportPostCreateBy';
// import ReportViewDetail from '@app/pages/report/reportViewDetail/ReportViewDetail';
// import ReportPostPublishTimeAndDataType from '@pages/report/ReportPostPublishTimeAndDataType';
// import RepostAdvertising from '@pages/report/RepostAdvertising';

import Header from './header/Header';
import Footer from './footer/Footer';
import MenuSidebar from './menu-sidebar/MenuSidebar';

import {URI_INTERNAL} from '../../utils/pathLocations';
import ApiRoleMapping from '@app/pages/apiRoleMapping/ApiRoleMapping';
import ApiRoleMappingAdd from '@app/pages/apiRoleMapping/ApiRoleMappingAdd';
import ApiRoleMappingEdit from '@app/pages/apiRoleMapping/ApiRoleMappingEdit';
import {appRoutes} from '@app/routes';

// import PageLoading from '../../components/page-loading/PageLoading';

const Main = () => {
    // const [appLoadingState, updateAppLoading] = useState(false);
    // const dispatch = useDispatch();


    // useEffect(() => {

    // }, []);

    // const token = localStorage.getItem(TOKEN_KEY);

    // // const [permitted, setPermitted] = useState()

    // if (token) {
    // }

    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('login-page');
    document.getElementById('root').classList.remove('hold-transition');

    document.body.className += ' sidebar-mini';

    const toggleMenuSidebar = () => {
        document.body.classList.add('sidebar-collapse');
        document.body.classList.remove('sidebar-open');
    };

    const template = (
        <>
            <Header />

            <MenuSidebar />

            <div className="content-wrapper">
                <div className="pt-3" />
                <section className="content">
                    {/* <Switch>
                        <Route exact path="/profile" component={Profile} />
                        <Route exact path="/" component={Dashboard} />
                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNT_PATH}
                            component={Account}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNT_PATH_ADD}
                            component={AccountAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.ACCOUNT_PATH_EDIT}
                            component={AccountEdit}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.EMAILCONFIG_PATH}
                            component={EmailConfig}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.EMAILCONFIG_CREATE_PATH}
                            component={EmailConfigAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.EMAILCONFIG_EDIT_PATH}
                            component={EmailConfigEdit}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.LOGIN_HISTORY_PATH}
                            component={LoginHistory}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.STATISTIC_HISTORY_PATH}
                            component={StatisticLoginHistory}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.APIROLEMAPPING_PATH}
                            component={ApiRoleMapping}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.APIROLEMAPPING_CREATE_PATH}
                            component={ApiRoleMappingAdd}
                        />
                        <Route
                            exact
                            path={URI_INTERNAL.APIROLEMAPPING_EDIT_PATH}
                            component={ApiRoleMappingEdit}
                        />

                        <Route
                            exact
                            path={URI_INTERNAL.LOG_PATH}
                            component={Log}
                        />
                    </Switch> */}
                    <Switch>
                        {appRoutes.map((r) => (
                            <Route
                                // key={r.path}
                                exact
                                path={r.path}
                                component={r.component}
                            />
                        ))}
                    </Switch>
                </section>
            </div>
            <Footer />
            <div
                id="sidebar-overlay"
                role="presentation"
                onClick={toggleMenuSidebar}
                onKeyDown={() => {}}
            />
        </>
    );

    // if (appLoadingState) {
    //     template = <PageLoading />;
    // } else {
    //     template = (
    //         <>
    //             <Header toggleMenuSidebar={toggleMenuSidebar} />

    //             <MenuSidebar />

    //             <div className="content-wrapper">
    //                 <div className="pt-3" />
    //                 <section className="content">
    //                     <Switch>
    //                         <Route exact path="/profile" component={Profile} />
    //                         <Route exact path="/" component={Dashboard} />
    //                     </Switch>
    //                 </section>
    //             </div>
    //             <Footer />
    //             <div
    //                 id="sidebar-overlay"
    //                 role="presentation"
    //                 onClick={toggleMenuSidebar}
    //                 onKeyDown={() => {}}
    //             />
    //         </>
    //     );
    // }

    return <div className="wrapper">{template}</div>;
};

export default Main;
